import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Enum

export enum PreferenceTagTypeEnum {
  guest = 'guest',
  booking = 'booking',
}

export enum PreferenceGroupSubTypeEnum {
  Flight = 'flight',
  Hotel = 'hotel',
  Cruise = 'cruise',
  TravelDocument = 'travel_document',
  Activity = 'activity',
  Visa = 'visa',
  FlightClassBusiness = 'flight_class:business',
  FlightClassEconomy = 'flight_class:economy',
  Product = 'product',
  FlightClass = 'flight_class:business|flight_class:economy',
}

// Model

export class PreferenceTagItemModel {
  id: string;
  name: string;
}

export class PreferenceTagLiteModel extends CommonModel {
  name: string;
  type: string;

  @Type(() => PreferenceTagItemModel)
  preferences: PreferenceTagItemModel[];
}

export class PreferenceTagModel extends PreferenceTagLiteModel {
  @Expose({ name: 'sub_type' })
  subType?: string | null;
}

// Input

export type getPreferenceTagsInput = {
  params: CommonParamInput;
};

export type getPreferenceTagInput = {
  id: string;
};

export type getPreferenceGroupsInput = {
  params: CommonParamInput & {
    type?: string;
    sub_type?: string;
  };
};

export type getPreferenceGroupInput = {
  id: string;
};

export type PreferenceTagItemInput = {
  id?: string;
  name: string;
};

export type PreferenceTagMutationInput = {
  name: string;
  type: string | null;
  preferences: PreferenceTagItemInput[];
  subType?: string | null;
};

export type PreferenceTagUpdateInput = {
  preferenceTagId: string;
  body: PreferenceTagMutationInput;
};

export type PreferenceTagDeleteInput = {
  preferenceTagId: string;
};
